import { FlexAligner, ListItem, Typography } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';

import { SettingsPreferences } from '@/components/SettingsPreferences.tsx';
import { useConfigStore } from '@/stores';
import { Icon, responsive } from '@/utils';

export const SettingsPanel = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const { portableMode } = useConfigStore();

  return (
    <FlexAligner direction='column' gap={responsive.spacing['5xlarge']} style={{ padding: '1rem' }}>
      <SettingsPreferences />
      {portableMode && (
        <ListItem
          Icon={Icon.LogOut}
          onClick={
            auth.isAuthenticated ? () => auth.signoutRedirect() : () => auth.signinRedirect()
          }
          elem={<Typography>{t(auth.isAuthenticated ? 'logout' : 'login')}</Typography>}
        />
      )}
    </FlexAligner>
  );
};
